enum FieldInputVariant {
  lightGray34Percent = 'light-gray-34-percent',
  dark80Percent = 'dark-80-percent',
  dark = 'dark',
  white = 'white',
  wispPink = 'wisp-pink',
  delicatePink = 'delicate-pink',
}

export { FieldInputVariant };
